export default __webpack_public_path__ + "static/media/mesh04.3ed34455.png";